/**
 * Punto mira MPR: mapeo pixel de viewport ↔ índices de volumen (X, Y, Z).
 * Alineado con mprRenderXZPlane / mprRenderYZPlane (Z 1:1 con stack + flipZ).
 */

function clamp(n, lo, hi) {
  const v = Math.round(Number(n) || 0)
  return Math.max(lo, Math.min(hi, v))
}

function zToRow(z, zSize, flipZ) {
  const zi = clamp(z, 0, Math.max(0, zSize - 1))
  return flipZ ? zSize - 1 - zi : zi
}

function rowToZ(row, zSize, flipZ) {
  const r = clamp(row, 0, Math.max(0, zSize - 1))
  return flipZ ? zSize - 1 - r : r
}

/**
 * @param {{ cols: number, rows: number, zDim: number }} size
 * @param {boolean} [flipZ]
 * @param {'axial'|'coronal'|'sagittal'} plane - plano mostrado en el viewport
 * @param {{ x: number, y: number }} pixel - coords imagen (col, row)
 * @param {number} sliceIndex - índice de scroll del viewport
 */
export function pixelToVolumeIndices({ plane, pixel, sliceIndex, size, flipZ = false }) {
  const cols = Math.max(1, Number(size && size.cols) || 1)
  const rows = Math.max(1, Number(size && size.rows) || 1)
  const zDim = Math.max(1, Number(size && size.zDim) || 1)

  if (plane === 'coronal') {
    const col = clamp(pixel && pixel.x, 0, cols - 1)
    const row = clamp(pixel && pixel.y, 0, zDim - 1)
    const slice = clamp(sliceIndex, 0, rows - 1)
    return {
      x: col,
      y: slice,
      z: rowToZ(row, zDim, flipZ),
    }
  }
  if (plane === 'sagittal') {
    const col = clamp(pixel && pixel.x, 0, rows - 1)
    const row = clamp(pixel && pixel.y, 0, zDim - 1)
    const slice = clamp(sliceIndex, 0, cols - 1)
    return {
      x: slice,
      y: col,
      z: rowToZ(row, zDim, flipZ),
    }
  }
  const col = clamp(pixel && pixel.x, 0, cols - 1)
  const row = clamp(pixel && pixel.y, 0, rows - 1)
  const slice = clamp(sliceIndex, 0, zDim - 1)
  return {
    x: col,
    y: row,
    z: slice,
  }
}

/**
 * Índice de scroll (slice) que debe mostrar un viewport para el punto {x,y,z}.
 */
export function volumeIndicesToViewportSlice({ plane, x, y, z, size }) {
  const cols = Math.max(1, Number(size && size.cols) || 1)
  const rows = Math.max(1, Number(size && size.rows) || 1)
  const zDim = Math.max(1, Number(size && size.zDim) || 1)
  if (plane === 'coronal') return clamp(y, 0, rows - 1)
  if (plane === 'sagittal') return clamp(x, 0, cols - 1)
  return clamp(z, 0, zDim - 1)
}

/**
 * Pixel (col,row) en la imagen del viewport donde dibujar la cruz.
 */
export function volumeIndicesToImagePixel({ plane, x, y, z, size, flipZ = false }) {
  const cols = Math.max(1, Number(size && size.cols) || 1)
  const rows = Math.max(1, Number(size && size.rows) || 1)
  const zDim = Math.max(1, Number(size && size.zDim) || 1)
  if (plane === 'coronal') {
    return { x: clamp(x, 0, cols - 1), y: zToRow(z, zDim, flipZ) }
  }
  if (plane === 'sagittal') {
    return { x: clamp(y, 0, rows - 1), y: zToRow(z, zDim, flipZ) }
  }
  return { x: clamp(x, 0, cols - 1), y: clamp(y, 0, rows - 1) }
}

export function clampVolumePoint(point, size) {
  if (!point || !size) return null
  return {
    x: clamp(point.x, 0, Math.max(0, (size.cols || 1) - 1)),
    y: clamp(point.y, 0, Math.max(0, (size.rows || 1) - 1)),
    z: clamp(point.z, 0, Math.max(0, (size.zDim || 1) - 1)),
  }
}
